import React, { useContext, useEffect } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import { Box } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import FastIcon from "./FastIcon";
import { AuthContext } from "../context/AuthProvider";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ProfileMenu = ({
  open,
  handleClose,
  setIsLangSelecter,
  anchorEl,
  info,
}: any) => {
  const { setAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const lang = [
    {
      title: "Русский",
      id: "ru",
    },
    {
      title: "Қазақ",
      id: "kz",
    },
    {
      title: "English",
      id: "en",
    },
  ];

  useEffect(() => {
    if (!localStorage.getItem("lang")) {
      localStorage.setItem("lang", "ru");
    }
  }, []);

  const exit = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    setAuthenticated(false);
    navigate("/");
  };

  return (
    <Menu
      anchorEl={anchorEl}
      id="account-menu"
      open={open}
      onClose={handleClose}
      onClick={handleClose}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          border: "1px solid rgba(1, 18, 36, 0.08)",
          boxShadow: "6px -3px 12px 0px rgba(0, 0, 0, 0.05)",
          width: "256px",
          borderRadius: "8px",
          li: {
            fontSize: "14px",
            fontWeight: 800,
            padding: "12px 16px",
          },
          ".lang": {
            fontSize: "12px",
            fontWeight: 600,
            color: "rgba(128, 137, 146, 1)",
          },

          mt: 1.5,
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          "&::before": {
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: "background.paper",
            transform: "translateY(-50%) rotate(45deg)",
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
      <MenuItem onClick={handleClose}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
          }}>
          {info?.avatar ? (
            <img src={info.avatar} className="menu-avatar" alt="img" />
          ) : (
            <FastIcon name={"profileMenuIcon"} />
          )}

          <Box
            sx={{
              paddingTop: "10px",
              paddingLeft: "12px",
              fontWeight: 600,
              fontSize: "14px",
              width: "150px",
              textWrap: "wrap",
              wordWrap: "break-word",
            }}>
            <Box>
              {info?.first_name} {info?.last_name}
            </Box>
          </Box>
        </Box>
      </MenuItem>
      <Divider />
      <MenuItem onClick={() => navigate("/studying")}>Мое обучение</MenuItem>
      <MenuItem onClick={() => navigate("/panel")}>
        Панель преподавателя
      </MenuItem>
      <Divider />
      <MenuItem onClick={() => navigate("/profile")}>Профиль</MenuItem>
      <Divider />
      <MenuItem onClick={handleClose}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
          onClick={() => setIsLangSelecter(true)}>
          <Box>
            <Box>{t("Язык")}</Box>
            <Box className={"lang"}>
              {
                lang.filter((el) => localStorage.getItem("lang") === el.id)[0]
                  ?.title
              }
            </Box>
          </Box>
          <LanguageIcon />
        </Box>
      </MenuItem>
      <Divider />
      <MenuItem onClick={handleClose}>Помощь</MenuItem>
      <Divider />
      <MenuItem onClick={exit}>Выйти</MenuItem>
    </Menu>
  );
};
export default ProfileMenu;
